module.exports = __webpack_public_path__ + "static/media/be.6651586a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/be.svg
// module id = 1431
// module chunks = 0